import type * as React from 'react';
import type { GroundingMenuListboxProps, GroundingMenuListboxState } from './GroundingMenuListbox.types';
import { useInputListbox_unstable } from '@fluentui-copilot/react-input-listbox';
import { useArrowNavigationGroup } from '@fluentui/react-tabster';

/**
 * Create the state required to render GroundingMenuListbox.
 *
 * The returned state can be modified with hooks such as useGroundingMenuListboxStyles_unstable,
 * before being passed to renderGroundingMenuListbox_unstable.
 *
 * @param props - props from this instance of GroundingMenuListbox
 * @param ref - reference to root HTMLElement of GroundingMenuListbox
 */
export const useGroundingMenuListbox_unstable = (
  props: GroundingMenuListboxProps,
  ref: React.Ref<HTMLDivElement>,
): GroundingMenuListboxState => {
  const focusAttributes = useArrowNavigationGroup({ axis: 'vertical', circular: true });

  return useInputListbox_unstable({ role: 'menu', ...props, ...focusAttributes }, ref);
};
